export default "__VITE_ASSET__03c1cfc0__"